export default function(type, value) {
  const proxy = {
    'camel-slug': value => value.replace(/([A-Z])/g, '-$1'),
  }

  return proxy[type](value)
}
